import { render, staticRenderFns } from "./contract-partner-sourcePersons.vue?vue&type=template&id=457f02fe"
import script from "./contract-partner-sourcePersons.vue?vue&type=script&lang=ts"
export * from "./contract-partner-sourcePersons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports